module.exports = __webpack_public_path__ + "img/workplay-5.9ef9214d.jpg";